export default __webpack_public_path__ + "static/media/icon_information_circle_24_Regular.c02fc082.svg";